module.exports = __webpack_public_path__ + "static/img/9.7a1667e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/sp/9.png
// module id = B+Mu
// module chunks = 0